import { welcomeOfferStageLabels, type WelcomeOfferStage } from "@/hooks/useWelcomeOffers"

export function WelcomeOfferStatus({ stage }: { stage: WelcomeOfferStage }) {
  const colors =
    stage === "details_received"
      ? "bg-blue-500/15 text-blue-600 dark:text-blue-300"
      : stage === "onboarded"
        ? "bg-green-500/15 text-green-700 dark:text-green-300"
        : "bg-muted text-secondary"
  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium ${colors}`}>
      {welcomeOfferStageLabels[stage]}
    </span>
  )
}
